import type {ReactNode} from 'react'
import {MutedText} from './MutedText'

interface TreeNodeDescriptionProps {
    children?: ReactNode
}

export function TreeNodeDescription({children}: TreeNodeDescriptionProps) {
    return (
        <MutedText size="xs" block truncate className="mt-0.5 ml-11 max-w-xs">
            {children}
        </MutedText>
    )
}
